'use strict';

import { Component } from 'react';
import { InstantSearch } from 'react-instantsearch/dom';
import createHistory from 'history/createBrowserHistory';
import Media from 'react-media';
import { createURL, searchStateToUrl, urlToSearchState } from './state';
import ScrollTo from "./ScrollTo";
import Filters from "./Filters";
import { Results } from "./Results";

class App extends Component {
	
	history = null;
	historyTimeout = null;
	recentChangeTimeout = null;
	unlisten = null;
	
	state = {
		showFilters: false,
	};
	
	constructor(props) {
		super(props);
		
		this.history = createHistory();
		
		const searchState = urlToSearchState(this.history.location);
		
		this.state = {
			recentlyChanged: false,
			searchState,
			searchKey: createURL(searchState),
		};
	}
	
	componentDidMount() {
		const { history } = this;
		
		this.unlisten = history.listen(location => {
			if (! location.state || location.state.searchKey !== this.state.searchKey) {
				this.setState({
					searchState: urlToSearchState(location),
				});
			}
		});
	}
	
	componentWillUnmount() {
		this.unlisten();
	}
	
	onSearchStateChange = (searchState) => {
		clearTimeout(this.historyTimeout);
		clearTimeout(this.recentChangeTimeout);
		
		// Only show change when it's not related to the query string
		// TODO: This should probably be done with connectStateResults
		const recentlyChanged = searchState.query === this.state.searchState.query;
		
		const state = { searchState, searchKey: createURL(searchState), recentlyChanged };
		
		this.historyTimeout = setTimeout(() => {
			this.history.push(
				searchStateToUrl(this.history.location, searchState),
				state
			);
		}, 1000);
		
		this.recentChangeTimeout = setTimeout(() => this.setState({ recentlyChanged: false }), 300);
		
		this.setState(state);
	};
	
	render() {
		const { recentlyChanged } = this.state;
		const config = {
			appId: this.props.algolia.app_id,
			apiKey: this.props.algolia.key,
			indexName: this.props.algolia.index,
			searchState: this.state.searchState,
			onSearchStateChange: this.onSearchStateChange,
			createURL
		};
		
		return (
			<div className="tailwind">
				<Media query={ { maxWidth: 768 } }>{ isSmall => (
					<InstantSearch { ...config }>
						<div className="md:flex">
							{ this.filters(isSmall) }
							<div className="flex-1" style={ { opacity: recentlyChanged ? 0.2 : 1 } }>
								<ScrollTo>
									<Results />
								</ScrollTo>
							</div>
						</div>
					</InstantSearch>
				) }</Media>
			</div>
		);
	}
	
	filters(isSmall) {
		const { showFilters } = this.state;
		
		let button = null;
		if (isSmall && ! showFilters) {
			button = (
				<div className="mb-2">
					<button className="block w-full btn btn-blue" onClick={ () => this.setState({ showFilters: true }) }>
						Show Filters
					</button>
				</div>
			);
		} else if (isSmall && showFilters) {
			button = (
				<div className="mb-2">
					<button className="block w-full btn btn-blue" onClick={ () => this.setState({ showFilters: false }) }>
						Hide Filters
					</button>
				</div>
			);
		}
		
		return (
			<div className={ isSmall ? 'w-full' : 'md:w-1/3 xl:w-1/4 flex-shrink-0 pr-4' }>
				{ button }
				<Filters className={ isSmall && ! showFilters ? 'hidden' : '' } />
			</div>
		);
	}
}

export default App;
